














import { Component, Inject, Mixins } from "vue-property-decorator";
import { IImportProviderData, IImportProviderMethods } from "@/models/imports";
import Context from "@/mixins/context";
import { TranslateResult } from "vue-i18n";

interface IImportAction {
  class?: string;
  disabled?: boolean;
  if: boolean;
  label: string | TranslateResult;
  method: () => Promise<any>;
  processing?: boolean;
}

@Component
export default class ImportActions extends Mixins(Context) {
  @Inject({ from: "importProvider" })
  public readonly $importProvider!: () => IImportProviderData;

  @Inject({ from: "importMethods" })
  public readonly $importMethods!: IImportProviderMethods;

  // Data

  public isProcessing: string[] = [];

  public get $importData() {
    return this.$importProvider();
  }

  // Computed

  public get actions(): IImportAction[] {
    return [
      {
        label: this.$t("_action.start_import"),
        method: () => this.process("start", this.$importMethods.start()),
        processing: this.isProcessing.includes("start"),
        class: "is-success",
        if: this.$importData.canStartImport
      },
      {
        label: this.$t("_action.cancel_import"),
        method: () => this.process("cancel", this.$importMethods.cancel()),
        processing: this.isProcessing.includes("cancel"),
        if: this.$importData.canCancelImport
      },
      {
        label: this.$t("_action.delete_import"),
        method: () => this.process("delete", this.$importMethods.delete()),
        processing: this.isProcessing.includes("delete"),
        class: "is-danger is-outlined",
        if: this.$importData.canDelete
      },
      {
        label: this.$t("_action.commit_import"),
        method: () => this.process("commit", this.$importMethods.commit()),
        processing: this.isProcessing.includes("commit"),
        class: "is-success is-outlined",
        if: this.$importData.canCommit
      }
    ];
  }

  public get availableActions() {
    return this.$_.filter(this.actions, action => action.if);
  }

  // Methods

  public async process(key: string, method: Promise<any>) {
    try {
      this.$set(this, "isProcessing", this.$_.union(this.isProcessing, [key]));
      await method;
    } finally {
      this.$set(this, "isProcessing", this.$_.without(this.isProcessing, key));
    }
  }
}
